import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import {darken, lighten, alpha} from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

import Bs4MainDispatch from './Bs4MainDispatch';
import Bs4MainWindow from './Bs4MainWindow';
import Bs4Kartoteka from './Bs4Kartoteka';
import Bs4AppBar from './Bs4AppBar/Bs4AppBar';

import { getBoxSx, SmallScreenContext } from './Bs4Theme/Bs4UxTemplates';
import { EventEmit } from './Bs4Components/Bs4Utils'
import { colorIsDark } from './Bs4Components/Bs4Utils';
import Bs4I18N from './Bs4I18N';
import { motion } from "motion/react"

const TOOLTIP_FORMELEMENT = 'formElement';
const TOOLTIP_MENUOPTION = 'option';
const TOOLTIP_REPORTOPTION = 'reportOption';
const TOOLTIP_REPORTFILTER = 'reportFilter';
const TOOLTIP_REPORTCOLUMN = 'reportColumn';
const TOOLTIP_TRIGGER_COMMAND = 'triggerCommand';
const TOOLTIP_TOPICON = 'topIcon';
const TOOLTIP_TOPRIGHT = 'topRight';
const TOOLTIP_LISTEDOPTION = 'listedOption';
const TOOLTIP_GENERAL = 'general';

const SET_TOOLTIP_OBJECT = 'set_tooltip_object';
const SET_CURRENT_TOOLTIP = 'set_current_tooltip'


//const ListItemStyled = styled(ListItem)(({ uxtemplate }) => ({}));

export default class Bs4ShowTooltip {
  ICON = "fa-solid fa-user-graduate";

  constructor(bs4Kartoteka, bs4Option, bs4RoboAssist) {
    this.bs4Kartoteka = bs4Kartoteka;
    this.bs4Option = bs4Option;
    this.eventEmit = new EventEmit();    
    this.bs4RoboAssist = bs4RoboAssist;
  }

  bs4Option = null;
  tooltipArray = [];
  currentTooltip = null;

  setCurrentTooltip = (newCurrentTooltip) => {
    this.currentTooltip = newCurrentTooltip;
    this.eventEmit.trigger(SET_CURRENT_TOOLTIP, this.currentTooltip);
  }

  addTooltip = (message) => {    
    console.log('...SHOW_TOOLTIP...')
    this.tooltipArray.push(message._Komunikat);
  }

  setTooltipObject = (tooltipObject) => {      
    this.eventEmit.trigger(SET_TOOLTIP_OBJECT, tooltipObject);
  }

  showObjectTooltip = (newTooltip) => {
    if (newTooltip) {
      if (newTooltip !== this.currentTooltip) this.closeTooltip();
      this.setCurrentTooltip(newTooltip);
    }

    if (!this.currentTooltip) {
      this.setTooltipObject(null);
      return;
    }

    if (!this.canShowObjectTooltip(this.currentTooltip)) {
      console.log('...Bs4ShowTooltip...canShowObjectTooltip...Not.ready.yet.', this.currentTooltip);
      return;
    }

    switch (this.currentTooltip.uxType) {
      case TOOLTIP_FORMELEMENT: this.openFormElement(this.currentTooltip); break;
      case TOOLTIP_MENUOPTION: this.openMenuOption(this.currentTooltip); break;
      case TOOLTIP_REPORTOPTION: this.openReportOption(this.currentTooltip); break;
      case TOOLTIP_REPORTFILTER: this.openReportFilter(this.currentTooltip); break;
      case TOOLTIP_REPORTCOLUMN: this.openReportColumn(this.currentTooltip); break;
      case TOOLTIP_TRIGGER_COMMAND: this.openTriggerCommand(this.currentTooltip); break;
      case TOOLTIP_TOPICON: this.openTopIcon(this.currentTooltip); break;
      case TOOLTIP_TOPRIGHT: this.openTopRight(this.currentTooltip); break;
      case TOOLTIP_LISTEDOPTION: this.openListedOption(this.currentTooltip); break;
      case TOOLTIP_GENERAL: this.openGeneral(this.currentTooltip); break;      
      default: break;
    };
  };

  canShowObjectTooltip = (tooltip) => {
    switch (tooltip.uxType) {
      case TOOLTIP_FORMELEMENT: return this.canShowFormElement(tooltip);
      case TOOLTIP_MENUOPTION: return this.canShowMenuOption(tooltip); 
      case TOOLTIP_REPORTOPTION: return this.canShowReportOption(tooltip);
      case TOOLTIP_REPORTFILTER: return this.canShowReportFilter(tooltip);
      case TOOLTIP_REPORTCOLUMN: return this.canShowReportColumn(tooltip);
      case TOOLTIP_TRIGGER_COMMAND: return this.canShowTriggerCommand(tooltip);
      case TOOLTIP_TOPICON: return this.canShowTopIcon(tooltip);
      case TOOLTIP_TOPRIGHT: return this.canShowTopRight(tooltip);
      case TOOLTIP_LISTEDOPTION: return this.canShowListedOption(tooltip);
      case TOOLTIP_GENERAL: return this.canShowGeneral(tooltip);  
      default: return null;
    };
  };

  clear = () => {
    this.closeTooltipAndView();
    this.tooltipArray = [];
    this.setCurrentTooltip(null);    
  }

  closeTooltip = (tooltip) => {
    if (!tooltip) tooltip = this.currentTooltip;
    if (tooltip?.object?.onClose) {
      tooltip.object.onClose(true);
    }
    if (tooltip?.object) delete tooltip.object;
  }  

  closeTooltipAndView = (tooltip) => {    
    if (tooltip && tooltip !== this.currentTooltip) {
      return;
    }
    if (tooltip && !tooltip?.object?.onClose) {
      return;
    }

    this.closeTooltip(tooltip);
    this.setTooltipObject(null);
  }

  getNextTooltip = (tooltip) => {
    const index = this.tooltipArray.indexOf(tooltip);    
    for (let i = index + 1; i < this.tooltipArray.length; i++) {
      const nextTooltip = this.tooltipArray[i];
      const found = this.canShowObjectTooltip(nextTooltip);
      if (found) return nextTooltip;
      else {
        console.log('...Bs4ShowTooltip...getNextTooltip', tooltip);
      }
    }    
    return null;
  }

  getPrevTooltip = (tooltip) => {
    const index = this.tooltipArray.indexOf(tooltip);
    for (let i = index - 1; i >= 0; i--) {
      const prevTooltip = this.tooltipArray[i];
      const found = this.canShowObjectTooltip(prevTooltip);
      if (found) return prevTooltip;
      else {
        console.log('...Bs4ShowTooltip...getPrevTooltip', tooltip);
      }
    }
    return null;
  }

  nextTooltip = (event) => {        
    const nextTooltip = this.getNextTooltip(this.currentTooltip);
    this.showObjectTooltip(nextTooltip);
  }

  prevTooltip = (event) => {    
    const prevTooltip = this.getPrevTooltip(this.currentTooltip);
    this.showObjectTooltip(prevTooltip);
  }    

  canShowFormElement = (tooltip) => {
    try {
      return this.bs4Option.bs4Form.canShowTooltip(this.bs4Option.bs4Form, tooltip.uxId);
    } catch(error) {};
    return null;
  };

  canShowMenuOption = (tooltip) => {    
    try {
      if (this.bs4Kartoteka.cardMenu?.canShowTooltip) {
        if (this.bs4Kartoteka.cardMenu.canShowTooltip(tooltip.uxId)) return this.bs4Kartoteka.cardMenu;  
      }
      if (Bs4MainWindow.instance.mainBs4Kartoteka?.cardMenu?.canShowTooltip) {
        if (Bs4MainWindow.instance.mainBs4Kartoteka.cardMenu.canShowTooltip(tooltip.uxId)) return Bs4MainWindow.instance.mainBs4Kartoteka.cardMenu; 
      }
    } catch(error) {
      console.log('...???...canShowMenuOption...E', error);
    };    
    return null;
  };

  canShowReportOption = (tooltip) => {
    try {
      if (this.bs4Option.bs4Grid.reportOptionMenu.canShowTooltip(tooltip.uxId)) return this.bs4Option.bs4Grid.reportOptionMenu;
    } catch(error) {};
    return null;
  };

  canShowReportFilter = (tooltip) => {
    return this.canShowFormElement(tooltip);
  };

  canShowReportColumn = (tooltip) => {
    try {
      return this.bs4Option.bs4Grid?.tabulator?.getColumn(tooltip.uxId)?.getElement();
    } catch (error) {
      console.log('...Bs4ShowTooltip...canShowReportColumn', error);
    }
    return null;
  };

  canShowTriggerCommand = (tooltip) => {
    try {
      // return this.bs4Option.bs4Grid.showTooltip(tooltip.uxId);
      return this.bs4Option.bs4Grid.showTooltip;
    } catch(error) {};
    return null;
  };

  canShowTopIcon = (tooltip) => {
    // try {      
    //   console.log('...???...canShowTopIcon...1.', Bs4AppBar.instance.getIncomingItem(tooltip.uxId));
    //   return Bs4AppBar.instance.getIncomingItem(tooltip.uxId);
    // } catch(error) {};
    return true;
  };

  canShowTopRight = (tooltip) => {
    for (const checkedMenu of [Bs4AppBar.instance?.rightMenu, Bs4AppBar.instance?.plusTopMenu]) {
      if (!checkedMenu) continue;
      if (checkedMenu.canShowTooltip(tooltip.uxId)) {
        return checkedMenu;
      }
    }
    
    return null;
  };

  canShowListedOption = (tooltip) => {
    try {     
      return this.bs4Option.bs4Grid.showTooltip;
    } catch(error) {};
    return null;
  };

  canShowGeneral = (tooltip) => {
    return true;
  };  

  openFormElement = (tooltip) => {                
    this.bs4Option.bs4Form.setShowTooltip(
      tooltip.uxId, 
      (ref, onClose) => {
        tooltip.object = {object: ref.current, onClose: onClose}; 
        this.setTooltipObject(tooltip);
      }, 
      () => this.closeTooltipAndView(tooltip),
    );
  };

  openItemMenu = (tooltip, menu) => {
    if (!menu) return;
    menu.showTooltip(
      tooltip.uxId, 
      (ref, onClose) => {
        tooltip.object = {object: ref?.current, onClose: onClose};
        this.setTooltipObject(tooltip);
      }, 
      () => this.closeTooltipAndView(tooltip),      
    );
  }

  openMenuOption = (tooltip) => {   
    this.openItemMenu(tooltip, this.canShowMenuOption(tooltip))
  };

  openReportOption = (tooltip) => {    
    this.openItemMenu(tooltip, this.bs4Option.bs4Grid.reportOptionMenu)
  };

  openTopRight = (tooltip) => {       
    this.openItemMenu(tooltip, this.canShowTopRight(tooltip));
  };

  openReportFilter = (tooltip) => {
    this.bs4Option.bs4Form.setShowTooltip(
      tooltip.uxId, 
      (ref, onClose) => {
        tooltip.object = {object: ref.current, onClose: onClose};
        this.setTooltipObject(tooltip);
      }, 
      () => this.closeTooltipAndView(tooltip),
    );
  };

  openReportColumn = (tooltip) => {    
    const column = this.bs4Option.bs4Grid.tabulator?.getColumn(tooltip.uxId);
    tooltip.object = {object: column?.getElement()}
    this.setTooltipObject(tooltip);
  };

  openTriggerCommand = (tooltip) => {
    const item = this.bs4Option.bs4Grid.showTooltip(tooltip.uxId);
    tooltip.object = {object: item?.ref?.current};
    this.setTooltipObject(tooltip);
  };

  openTopIcon = (tooltip) => {    
    Bs4AppBar.instance.showTooltip(
      tooltip.uxId, 
      (ref, onClose) => {
        tooltip.object = {object: ref.current, onClose: onClose};
        this.setTooltipObject(tooltip);
      }, 
    );    
  };

  openListedOption = (tooltip) => {    
    this.bs4Option.bs4Grid.showTooltip(
      tooltip.uxId, 
      (ref, onClose) => {
        tooltip.object = {object: ref.current, onClose: onClose};
        this.setTooltipObject(tooltip);
      }
    );
  };

  openGeneral = (tooltip) => {    
    tooltip.object = {object: null,};
    this.setTooltipObject(tooltip);
  };

  getObjectRect = (tooltip, screenRect) => {
    const enlargement = 0;
    if (!tooltip?.object?.object) {
      return {rect: null, leftRect: null, topRect: null, rightRect: null, bottomRect: null, biggestRect: null};
    }
    
    const rect0 = tooltip?.object?.object?.getBoundingClientRect()

    const rect = {
      left: rect0.left - enlargement,
      top: rect0.top - enlargement,
      width: rect0.width + enlargement * 2,
      height: rect0.height + enlargement * 2,
    }

    const leftRect = {      
      type: 'left',
      left: 0,
      top: 0,
      width: rect.left,
      height: screenRect.height,
    }    

    const topRect = {      
      type: 'top',
      left: 0,
      top: 0,
      width: screenRect.width,
      height: rect.top,
    }

    const rightRect = {
      type: 'right',
      left: rect.left + rect.width,
      top: 0,
      width: screenRect.width - rect.left - rect.width,
      height: screenRect.height,
    }

    const bottomRect = {
      type: 'bottom',
      left: 0,
      top: rect.top + rect.height,
      width: screenRect.width,
      height: screenRect.height - rect.top - rect.height,
    }

    leftRect.area = leftRect.width * leftRect.height;
    topRect.area = topRect.width * topRect.height;
    rightRect.area = rightRect.width * rightRect.height;
    bottomRect.area = bottomRect.width * bottomRect.height;

    let biggestRect = leftRect;
    if (biggestRect.area < topRect.area) biggestRect = topRect;
    if (biggestRect.area < rightRect.area) biggestRect = rightRect;
    if (biggestRect.area < bottomRect.area) biggestRect = bottomRect;

    return {rect, leftRect, topRect, rightRect, bottomRect, biggestRect};
  }

  refShowTooltip = {current: null};
  ViewShowTooltip = (props) => {
    const [tooltip, setTooltip] = React.useState(null);
    const [currentTooltip, setCurrentTooltip] = React.useState(this.currentTooltip);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl) && Boolean(currentTooltip);
    const [resumeTutorialTT, quitTheTutorialTT] = Bs4I18N.useTTA([
      ['Resume tutorial', 'Wznów samouczek', 'ViewShowTooltip'],
      ['Quit the tutorial', 'Zakończ samouczek', 'ViewShowTooltip'],
    ]);

    const handleClickOpenMenu = (event, ref) => {      
      if (currentTooltip) setAnchorEl(this.refShowTooltip.current);
      else {
        Bs4MainDispatch.commandParser('Bs4RobotClick', {
          optionId: this.bs4Option.optionId, 
          currCardViewId: this.bs4Kartoteka.bs4KartotekaId
        }, this.bs4Kartoteka.bs4KartotekaId);
      }
    };

    const handleShowTooltip = () => {      
      this.showObjectTooltip();
      handleCloseMenu();
    }

    const handleCloseTooltip = () => {      
      Bs4MainDispatch.commandParser('Bs4TooltipClick', {
        optionId: this.bs4Option.optionId, 
        tooltipId: this.currentTooltip.tooltipId, 
        arrow: 'show',
        action: 'finish',
        currCardViewId: this.bs4Kartoteka.bs4KartotekaId
      }, this.bs4Kartoteka.bs4KartotekaId);
      this.clear();
      handleCloseMenu();
    }

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    React.useEffect(() => {                  
      this.eventEmit.on(SET_TOOLTIP_OBJECT, setTooltip);
      this.eventEmit.on(SET_CURRENT_TOOLTIP, setCurrentTooltip);
      return () => {
        this.eventEmit.off(setTooltip);
        this.eventEmit.off(setCurrentTooltip);
      }
    }, [setTooltip, setCurrentTooltip]);

    if (!this.bs4RoboAssist) return null;

    return (
      <React.Fragment>
        <IconButton 
          ref={this.refShowTooltip}
          onClick={handleClickOpenMenu}        
        >
          {/* {currentTooltip ? <i className="fa-regular fa-robot fa-fade"></i> : <i className="fa-regular fa-robot"></i>}                     */}
          {currentTooltip ? <i className="fa-solid fa-robot"></i> : <i className="fa-regular fa-robot"></i>}                    
        </IconButton>        
        <Menu 
          anchorEl={anchorEl} 
          open={open} 
          onClose={handleCloseMenu} 
          variant='menu'
        > 
          <MenuItem onClick={handleShowTooltip}>
            <ListItemText>
              <Typography>
              <span>{resumeTutorialTT}</span>
              {currentTooltip?.topTitle ? <span style={{fontWeight: 'bold'}}>{' '+currentTooltip.topTitle}</span> : null}
              </Typography>
            </ListItemText>
          </MenuItem>
          <MenuItem onClick={handleCloseTooltip}>
            <ListItemText>
            <Typography>
              <span>{quitTheTutorialTT}</span>
              {currentTooltip?.topTitle ? <span style={{fontWeight: 'bold'}}>{' '+currentTooltip.topTitle}</span> : null}
              </Typography>
            </ListItemText>
          </MenuItem>
        </Menu>
      </React.Fragment>
    )
  }

  
  //  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.15 -0.15 5.3 5.3">
  //    <path d="M 0 0 H 5 V 5 H 0 V 0 Z M 1 2 V 3 Q 1 4 2 4 H 3 Q 4 4 4 3 V 2 Q 4 1 3 1 H 2 Q 1 1 1 2 Z" stroke="#FF0000" stroke-width="0.3" fill="#0000ff"/>
  //  </svg>

  //  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2.1 -2.1 8.2 8.2">
  //    <path d="M -2 2 A 1 1 0 0 1 6 2 A 1 1 0 0 1 -2 2 Z M 0 1 V 3 Q 0 4 1 4 H 3 Q 4 4 4 3 V 1 Q 4 0 3 0 H 1 Q 0 0 0 1 Z" stroke="#FF0000" stroke-width="0.2" fill="#0000ff"/>
  //  </svg>

  getSvgGap = (rect, screenRect, theme) => {
    if (!rect) return '';

    const br = theme.shape.borderRadius;

    const r = Math.max(screenRect.width, screenRect.height) / 3.0;
    const xr = rect.left + (rect.width / 2.0);
    const yr = rect.top + (rect.height / 2.0);    

    const x1 = rect.left - br;
    const y1 = rect.top - br;

    const x2 = rect.left + rect.width + br;
    const y2 = rect.top + rect.height + br;
    
    return `M ${x1} ${y1+br} V ${y2-br} Q ${x1} ${y2} ${x1+br} ${y2} H ${x2-br} Q ${x2} ${y2} ${x2} ${y2-br} V ${y1+br} Q ${x2} ${y1} ${x2-br} ${y1} H ${x1+br} Q ${x1} ${y1} ${x1} ${y1+br} Z`
  }

  getSvgCircle = (rect, screenRect, theme) => {
    if (!rect) return '';

    const br = theme.shape.borderRadius;

    const r = Math.max(screenRect.width, screenRect.height) / 3.0;
    const xr = rect.left + (rect.width / 2.0);
    const yr = rect.top + (rect.height / 2.0);    

    const x1 = rect.left - br;
    const y1 = rect.top - br;

    const x2 = rect.left + rect.width + br;
    const y2 = rect.top + rect.height + br;

    return `M ${xr-r} ${yr} A 1 1 0 0 1 ${xr+r} ${yr} A 1 1 0 0 1 ${xr-r} ${yr} Z ${this.getSvgGap(rect, screenRect, theme)}`
  }
  
  ViewSvg = (props) => {
    const {tooltip, rect, screenRect} = props;
    const showTooltip = this;
    const [innitialPosition, setInitialPosition] = React.useState({top: 0, left: 0, bottom: 0, right: 0, opacity: 0,});
    const [animatePosition, setAnimatePosition] = React.useState({top: 0, left: 0, bottom: 0, right: 0, opacity: 0,});
    const theme = useTheme();       
    const [fillColor, setFillColor] = React.useState('#00000055');

    React.useEffect(() => {      
      if (Boolean(tooltip?.fillColor)) setFillColor(tooltip.fillColor || '#00000011');
    }, [tooltip?.fillColor, setFillColor]);

    const d = `M 0 0 H ${screenRect.width} V ${screenRect.height} H 0 V 0 Z ${this.getSvgGap(rect, screenRect, theme)}`;    

    React.useEffect(() => {      
      const rect = this.refShowTooltip?.current?.getBoundingClientRect();      

      if (!rect) {
        setInitialPosition({top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, opacity: 1, borderRadius: 99});
        setAnimatePosition({top: 0, left: 0, bottom: 0, right: 0, opacity: 0.2, borderRadius: 0});
        return;
      }

      if (Boolean(props.tooltip) && !props.open) {
        setInitialPosition({top: rect.top, left: rect.left, bottom: window.innerHeight - rect.bottom, right: window.innerWidth - rect.right, opacity: 1, borderRadius: 99});
        setAnimatePosition({top: 0, left: 0, bottom: 0, right: 0, opacity: 0.2, borderRadius: 0});
      }

      if (!Boolean(props.tooltip) && props.open) {
        setInitialPosition({top: 0, left: 0, bottom: 0, right: 0, opacity: 0.2, borderRadius: 0});
        setAnimatePosition({top: rect.top, left: rect.left, bottom: window.innerHeight - rect.bottom, right: window.innerWidth - rect.right, opacity: 1, borderRadius: 99});
      }          
    }, [
      this.refShowTooltip?.current, 
      setInitialPosition,
      setAnimatePosition,
      props.tooltip,
      props.open,
    ]);
  

    const handleAnimationComplete = (latest) => {
      props?.onAnimationComplete(latest.opacity === 0.2);
    }

    return (
      <motion.div 
        style={{
          position: 'fixed', 
          overflow: 'hidden',
        }}
        initial={innitialPosition}
        animate={animatePosition}
        transition={{
          duration: 0.3, 
          //type: "spring",
          //ease: "easeOut"
        }}
        // onAnimationStart={handleAnimationStart}
        onAnimationComplete={handleAnimationComplete}
      >            
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox={`0 0 ${screenRect.width} ${screenRect.height}`}         
        style={{
          // position: 'fixed', 
          // left: '0px', 
          // top: '0px',
          width: '100%',
          height: '100%',
          overflow: 'hidden',      
        }}
          //filter={'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.5))'}
      >
        <path 
          d={d} 
          //fill={alpha(object.tooltip.backgroundColor, 0.2)}
          // fill={tooltip?.boxSx?.backgroundColor || "#000000"}
          fill={fillColor}
        />
        {/* <path 
          d={showTooltip.getSvgCircle(object, screenRect)} 
          //stroke={object.tooltip.backgroundColor} 
          //strokeWidth='0.5' 
          fill={alpha(object.tooltip.backgroundColor, 0.2)}
        /> */}
      </svg>
      </motion.div>
    )
  }

  GetImageView = (props) => {    
    if (!props?.tooltip?.imageAbove) return null;
    const src = Bs4MainDispatch.getUrlPath(props.tooltip.imageAbove);

    return (
      <img 
        src={src}
        alt={props.tooltip.imageAbove} 
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit:  'scale-down',          
        }}
      />
    )
  }

  getPositopnViewTooltipContent = (tooltip, rect, biggestRect, refBox, sizeArrow, margin) => {
    let translate = null, positionArrow = null, translateArrow = null, translateArrowBox = null;
    if (tooltip?.uxType === 'general' ) {
    } else if (rect && refBox.current && biggestRect?.type) {
      const rectBox = refBox.current.getBoundingClientRect();

      if (biggestRect.type === 'left' || biggestRect.type === 'right') {
        const sizeArrowHeight = sizeArrow / 0.71;
        const sizeArrowWidth = sizeArrow;
        if (biggestRect.type === 'left') {
          positionArrow = {
            top: 0, 
            right: 0,
            height: sizeArrowHeight,
            width: sizeArrowWidth,
            marginRight: -margin,
          };
          // const x = 
          translateArrowBox = {transform: `translate(${-sizeArrowHeight / 2}px, ${(sizeArrowHeight - sizeArrowWidth) / 2}px) rotate(45deg)`};
        }
        if (biggestRect.type === 'right') {
          positionArrow = {
            top: 0, 
            left: 0,
            height: sizeArrowHeight,
            width: sizeArrowWidth,
            marginLeft: -margin,
          };
          translateArrowBox = {transform: `translate(${sizeArrowHeight / 2}px, ${-(sizeArrowHeight - sizeArrowWidth) / 2}px) rotate(45deg)`};
        }
        const centerBox = 0 + (rectBox.height / 2.0);
        const centerArrow = sizeArrow + (sizeArrowHeight / 2.0);
        const centerObject = rect.top + (rect.height / 2.0);            
        let move = centerObject - centerBox;            
        const overTop = 0 - move;
        const overBottom = rectBox.height + move - biggestRect.height;
        if (overTop > 0) move += overTop;
        if (overBottom > 0) move -= overBottom;
        translate = {transform: `translate(0px, ${move}px)`};
        const moveArrow = centerObject - centerArrow - move;
        translateArrow = {transform: `translate(0px, ${moveArrow}px)`}
        // console.log('...Bs4ShowTooltip...content...Eff.Y', centerBox, centerObject, centerArrow, move, moveArrow, sizeArrow);
      }

      if (biggestRect.type === 'top' || biggestRect.type === 'bottom') {
        const sizeArrowHeight = sizeArrow;
        const sizeArrowWidth = sizeArrow / 0.71;
        if (biggestRect.type === 'top') {
          positionArrow = {
            bottom: 0, 
            left: 0,
            height: sizeArrowHeight,
            width: sizeArrowWidth,
            marginBottom: -margin,
          };
          translateArrowBox = {transform: `translate(${-(sizeArrowWidth - sizeArrowHeight) / 2}px, ${-sizeArrowWidth / 2}px) rotate(45deg)`};
        }
        if (biggestRect.type === 'bottom') {
          positionArrow = {
            top: 0, 
            left: 0,
            height: sizeArrowHeight,
            width: sizeArrowWidth,
            marginTop: -margin,
          };
          translateArrowBox = {transform: `translate(${(sizeArrowWidth - sizeArrowHeight) / 2}px, ${sizeArrowWidth / 2}px) rotate(45deg)`};
        }
        const centerBox = 0 + (rectBox.width / 2.0);
        const centerArrow = sizeArrow + (sizeArrowWidth / 2.0);
        const centerObject = rect.left + (rect.width / 2.0);            
        let move = centerObject - centerBox;            
        const overLeft = 0 - move;
        const overRight = rectBox.width + move - biggestRect.width;
        if (overLeft > 0) move += overLeft;
        if (overRight > 0) move -= overRight;
        translate = {transform: `translate(${move}px, 0px)`};
        let moveArrow = centerObject - centerArrow - move;
        translateArrow = {transform: `translate(${moveArrow}px, 0px)`};
        // console.log('...Bs4ShowTooltip...content...Eff.X', centerBox, centerObject, centerArrow, move, moveArrow, sizeArrow);
      }
    }
    return [translate, positionArrow, translateArrow, translateArrowBox];
  }

  ViewTooltipContent = React.forwardRef((props, ref) => { 
    const {tooltip, biggestRect, screenRect, rect} = props;
    const showTooltip = this;

    const theme = useTheme();
    const prev = Boolean(this.getPrevTooltip(this.currentTooltip));
    const next = Boolean(this.getNextTooltip(this.currentTooltip));
    
    const refBox = React.useRef(null);
    const margin = 2;
    const sizeArrow = parseFloat(theme.spacing(margin));
    const maxSize = React.useMemo(() => {      
      if (tooltip?.uxType === 'general') return {
        maxWidth: (screenRect?.width * 0.8)+'px', 
        maxHeight: (screenRect?.height * 0.8)+'px',
      }
      if (rect) return {
        maxWidth: biggestRect.width - 30, 
        maxHeight: biggestRect.height - 30
      };
      return null;
    }, [screenRect, biggestRect, tooltip?.uxType]);        
         
    const [resize, setResize] = React.useState(new Date());    
    const [translate, positionArrow, translateArrow, translateArrowBox] = React.useMemo(() => {
      return this.getPositopnViewTooltipContent(tooltip, rect, biggestRect, refBox, sizeArrow, margin);      
    }, [resize, tooltip, rect, biggestRect, refBox.current, sizeArrow, margin]);

    const visibility = React.useMemo(() => {
      if (tooltip?.uxType === 'general') return null;
      if (!rect || !translate) return {visibility: 'hidden'};
      return null;
    }, [rect, tooltip?.uxType, translate]);

    React.useEffect(() => {      
      if (tooltip?.tooltipId) {
        Bs4MainDispatch.commandParser('Bs4TooltipClick', {
          optionId: this.bs4Option.optionId, 
          tooltipId: tooltip.tooltipId, 
          arrow: 'show',
          currCardViewId: this.bs4Kartoteka.bs4KartotekaId
        }, this.bs4Kartoteka.bs4KartotekaId);
      }
    }, [tooltip]);    

    React.useEffect(() => {      
      const resizeObserver = new ResizeObserver((e) => setResize(new Date()));
      if (refBox.current) resizeObserver.observe(refBox.current);
      return () => resizeObserver.disconnect();
    }, [refBox?.current, setResize]);
    
    const handleClick = (e) => {
      Bs4MainDispatch.commandParserAfter(this.bs4Kartoteka.bs4KartotekaId);
    }  
    
    const handleClickClose = (e) => {
      showTooltip.closeTooltipAndView();      
    }    

    // tooltip.msg = 'werwerwe werwerw rwerwerwerwerwerwererwerwerwerwerwer werwerwerwerwerwerwer werwerwerwerwerwerwerwerwerwerkwrekrwlkerlwkerlwkerlwkrewlkrelwkerlwer wrerwerwererwerwer werwerwerwerwerwgdfgdfgdfgdfgd dfgdfgdfgdfgdfgdfgdfgdfg dfgdfgdfgdfgdfgdfg  gdfgdfgdfg'
    // tooltip.msg += tooltip.msg;
    // tooltip.msg += tooltip.msg;
    // tooltip.msg += tooltip.msg;
    // tooltip.msg += tooltip.msg;
    // console.log('...Bs4ShowTooltip...content...', translate);

    // console.log('...Bs4ShowTooltip...ViewTooltipContent...', rect, translate, visibility);

    return (
      <Box 
        ref={refBox}               
        sx={{
          display: 'inline-block',
          position: 'relative',
          overflow: 'hidden',          
          maxWidth: '100%',
          maxHeight: '100%',
          ...translate,        
          ...visibility,
          // border: 'solid #0000ff',  
        }}
      >
      <Stack 
        ref={ref}       
        direction="column" 
        spacing={0} 
        sx={{  
          position: 'relative',        
          justifyContent: "flex-start", 
          alignItems: "flex-start",
          ...tooltip.boxSx,
          margin: margin,
          pointerEvents: 'auto',
          //overflow: 'hidden',
          ...maxSize,
        }}
      >
        <Stack 
          direction="row" 
          spacing={0} 
          sx={{
            justifyContent: "space-between", 
            alignItems: "center", 
            width: '100%',
            padding: tooltip?.boxSx?.padding,            
          }}
        >
          <IconButton 
            disabled 
            sx={{
              color: 'inherit', 
              "&:disabled":{color: 'inherit'}
            }}
          >
            <i className="fa-regular fa-robot"></i>          
          </IconButton>
          <Typography dangerouslySetInnerHTML={{__html: tooltip.topTitle}} sx={{overflowWrap: 'anywhere', fontWeight: 'bold'}}/>          
          <IconButton 
            onClick={handleClickClose} 
            sx={{
              color: 'inherit', 
            }}>
            <i className="fa-regular fa-xmark-large"></i>
          </IconButton>
        </Stack>       
        <Box
          sx={{
            borderColor: tooltip?.boxSx?.borderColor,
            borderRadius: null,
            borderWidth: tooltip?.boxSx?.borderWidth,
            borderStyle: tooltip?.boxSx?.borderStyle+ ' none',
            width: '100%',         
            padding: tooltip?.boxSx?.padding,
            overflowX: 'hidden',
            overflowY: 'auto',
            flex: 1,
          }}
        >        
          <showTooltip.GetImageView tooltip={tooltip} sixe={props.size}/>
          <Typography onClick={handleClick} dangerouslySetInnerHTML={{__html: tooltip.msg}} sx={{overflowWrap: 'anywhere'}}/>
        </Box>
        <Stack
          direction="row"
          spacing={0}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            width: '100%',
            padding: tooltip?.boxSx?.padding,
          }}
        >   
          <IconButton 
            onClick={showTooltip.prevTooltip} 
            sx={{
              color: 'inherit', 
              visibility: prev ? 'visible' : 'hidden', 
            }}
          >
            <i className="fa-regular fa-arrow-left-long"></i>       
          </IconButton>
          <Typography dangerouslySetInnerHTML={{__html: tooltip.uxCounter}}/>
          <IconButton 
            onClick={showTooltip.nextTooltip} 
            sx={{
              color: 'inherit', 
              visibility: next ? 'visible' : 'hidden', 
            }} 
          >
            <i className="fa-regular fa-arrow-right-long"></i>
          </IconButton>
        </Stack>         
        {positionArrow ?
        <Box 
          sx={{
            position: 'absolute',
            boxSizing: 'content-box',
            ...positionArrow,
            ...translateArrow,                      
            overflow: 'hidden',
          }}
        >
          <Box 
            sx={{    
              boxSizing: 'border-box',
              border: 'solid',
              width: '100%',
              height: '100%',
              ...tooltip.boxSx,
              padding: 0, 
              borderRadius: 0,
              ...translateArrowBox, 
              // backgroundColor: 'transparent',
            }}
          />
        </Box>
        : null}
      </Stack>
      </Box>
    )
  });

  ViewTooltip = (props) => {    
    const {tooltip, screenRect, ...other} = props;    
    const {rect, leftRect, topRect, rightRect, bottomRect, biggestRect} = props.rects;
    const theme = useTheme();
    const showTooltip = this;
    const smallScreen = React.useContext(SmallScreenContext);    
    const flexDirection = React.useMemo(() => {
      if (!biggestRect) return null;
      if (biggestRect.type === 'left') return 'row-reverse';
      if (biggestRect.type === 'top') return 'column-reverse';
      if (biggestRect.type === 'right') return 'row';
      if (biggestRect.type === 'bottom') return 'column';
      return null;
    }, [biggestRect]);

    if (!Boolean(tooltip) || !props.open) return null;

    if (tooltip.uxType === 'general' ) {      

      return (             
        <showTooltip.ViewTooltipContent 
          tooltip={tooltip}
          screenRect={screenRect} 
          {...props}          
        />
      )
    }    

    if (!biggestRect) return null;

    return (   
      <Box          
        sx={{            
          display: 'flex',
          flexDirection: flexDirection,
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          position: 'fixed',
          left: biggestRect.left,
          top: biggestRect.top,
          width: biggestRect.width,
          height: biggestRect.height,
          // border: 'solid #ff0000',
          overflow: 'hidden',
        }}
      > 
        <showTooltip.ViewTooltipContent 
          tooltip={tooltip}
          screenRect={screenRect} 
          biggestRect={biggestRect} 
          rect={rect}
          {...props}            
        />
      </Box>
    )
  }

  defaultBoxSx = {
    color: "rgba(42, 42, 42, 1)",
    backgroundColor: "rgba(242, 242, 242, 1)",
    borderColor: "rgba(196, 196, 197, 1)",
    borderWidth: 2,
    borderRadius: 2,
    padding: 1,
    borderStyle: "solid",
    boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
  }

  ViewComponent = (prpos) => {
    const showTooltip = this;
    const theme = useTheme();    
    const [visibility, setVisibility] = React.useState(true)
    const [tooltip, setTooltip] = React.useState(null);
    const [open, setOpen] = React.useState(false)
    const [screenRect, setScreenRect] = React.useState({width: window.innerWidth, height: window.innerHeight})
    const [rects, setRect] = React.useState(this.getObjectRect(null, screenRect))    
    const refBackdrop = React.useRef(null);

    const scrollP = { behavior: 'smooth', block: 'nearest' }
    
    React.useEffect(() => {
      if (!tooltip) return;            
      // if (!tooltip.uxColor) tooltip.boxSx = this.defaultBoxSx;
      tooltip.boxSx = deepmerge(this.defaultBoxSx, getBoxSx(tooltip.uxColor, theme));
      const color1 = tooltip.boxSx?.color || "#000000";
      const color2 = tooltip.boxSx?.backgroundColor || "#ffffff";
      tooltip.fillColor = (colorIsDark(color1) < colorIsDark(color2)) ? color1 : color2;      
    }, [tooltip]);

    React.useEffect(() => {
      const resizeObserver = new ResizeObserver((e) => {
        const rect = refBackdrop.current.getBoundingClientRect();
        setScreenRect({width: rect.width, height: rect.height});        
      });
      if (refBackdrop.current) resizeObserver.observe(refBackdrop.current);
      
      return () => {
        resizeObserver.disconnect();
      }

    }, [refBackdrop?.current, setScreenRect]);

    React.useEffect(() => {            
      this.eventEmit.on(SET_TOOLTIP_OBJECT, setTooltip);
      return () => this.eventEmit.off(setTooltip);
    }, [setTooltip]);
    

    React.useEffect(() => {         
      const setAddTooltip = () => {
        this.addTooltip = (message) => {
          console.log('...SHOW_TOOLTIP...useEffect')
          const tooltip = message._Komunikat;
          this.tooltipArray.push(tooltip)
          if (!this.currentTooltip) this.showObjectTooltip(tooltip);
        }
        console.log('...SHOW_TOOLTIP...useEffect...after', this.currentTooltip, this.tooltipArray)
        if (!this.currentTooltip && this.tooltipArray.length > 0) this.showObjectTooltip(this.tooltipArray[0]);
      }

      if (this.bs4Option?.bs4Grid?.triggerTabulatorBuiltArry && !this.bs4Option?.bs4Grid?.tableBuilt) {
        this.bs4Option?.bs4Grid?.triggerTabulatorBuiltArry.push((built) => {
          if (!built) return;
          setAddTooltip();
        })
      } else setAddTooltip();

      this.bs4Kartoteka.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);
      const keyDown = (event) => {if (event.key === 'Escape') this.closeTooltipAndView();}
      document.addEventListener("keydown", keyDown, false);            

      return () => {
        document.removeEventListener("keydown", keyDown, false);
      }
    }, []);    
    
    React.useEffect(() => {      
      let rect = tooltip?.object?.object?.getBoundingClientRect();
      const isPositionChange = () => {
        const rect1 = rect;
        rect = tooltip?.object?.object.getBoundingClientRect();
        if (rect?.left !== rect1?.left) return true;
        if (rect?.top !== rect1?.top) return true;
        if (rect?.width !== rect1?.width) return true;
        if (rect?.height !== rect1?.height) return true;
        return false;
      }

      if (tooltip?.object?.object) tooltip.object.object.scrollIntoView(scrollP)
      setRect(this.getObjectRect(tooltip, screenRect));

      let resizeObserverTimeout1 = null;
      let resizeObserverTimeout2 = null;
      let resizeObserverInterval = null;

      const scrollLEventListener = (event) => {
        clearTimeout(resizeObserverTimeout1);
        clearTimeout(resizeObserverTimeout2);
        clearInterval(resizeObserverInterval);
        tooltip?.object?.object?.scrollIntoView(scrollP)
        resizeObserverTimeout1 = setTimeout(() => {
          if(isPositionChange()) setRect(this.getObjectRect(tooltip, screenRect));
          resizeObserverTimeout2 = setTimeout(() => {
            if(isPositionChange()) setRect(this.getObjectRect(tooltip, screenRect));            
            resizeObserverInterval = setInterval(() => {
              if(isPositionChange()) setRect(this.getObjectRect(tooltip, screenRect));
            }, 500);
          }, 200);
        }, 20);
      }      

      if (tooltip?.object?.object) {
        window.addEventListener('scroll', scrollLEventListener , true);
        scrollLEventListener(null);        
      }

      return () => {
        clearTimeout(resizeObserverTimeout1);
        clearTimeout(resizeObserverTimeout2);
        clearInterval(resizeObserverInterval);
        window.removeEventListener('scroll', scrollLEventListener, true);
      }
    }, [tooltip, tooltip?.object?.object, screenRect, setRect]);        

    React.useEffect(() => {
      return () => this.closeTooltip();
    }, [])

    const handleAnimationComplete = (open) => {      
      setOpen(open);
    }

    if (!this.bs4RoboAssist) return null;

    return (
      <Backdrop 
        id='Bs4ShowTooltip_Backdrop'
        ref={refBackdrop}
        open={Boolean(tooltip) || open} 
        visibility={visibility ? Bs4Kartoteka.VISIBILITY_VISIBLE : Bs4Kartoteka.VISIBILITY_HIDDEN}
        sx={{
          backgroundColor: 'transparent', 
          zIndex: (theme) => theme.zIndex.modal + 10, 
          pointerEvents: 'none',
        }}
      >
        <showTooltip.ViewSvg tooltip={tooltip} open={open} screenRect={screenRect} rect={rects?.rect} onAnimationComplete={handleAnimationComplete}/>
        <showTooltip.ViewTooltip tooltip={tooltip} open={open} screenRect={screenRect} rects={rects} visibility={visibility}/>
      </Backdrop>
    )
  }
} 